import React from 'react';

import { DutyHourTypeDynFlag } from 'generated';
import { useTranslation } from 'react-i18next';

import { ControlledFlagCheckbox } from 'components/shared/ControlledFields/ControlledFlagCheckbox';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

export const ExchangeSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <MultiStepForm.Section title={t('dutyHourTypes.section.exchange')}>
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="ALLOW_SWAP"
        label={t('dutyHourTypes.fieldName.allowSwapping')}
      />
    </MultiStepForm.Section>
  );
};
